import { render } from "./D3ClusterFormationGraph.vue?vue&type=template&id=0bed8ae4&scoped=true"
import script from "./D3ClusterFormationGraph.vue?vue&type=script&lang=js"
export * from "./D3ClusterFormationGraph.vue?vue&type=script&lang=js"

import "./D3ClusterFormationGraph.vue?vue&type=style&index=0&id=0bed8ae4&scoped=true&lang=css"
import "./D3ClusterFormationGraph.vue?vue&type=style&index=1&id=0bed8ae4&lang=scss"

import exportComponent from "/codebuild/output/src723/src/github.com/aqfer/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bed8ae4"]])

export default __exports__